
import LoginForm from "@/modules/login/components/forms/login/LoginForm.vue";
import { useI18n } from "vue-i18n";
import ChangePasswordForm from "@/modules/login/components/forms/change-password/ChangePasswordForm.vue";
import { mapGetters, mapActions } from "vuex";
import { RootGetters } from "@/store/getters";
import { LoginActions, LoginGetters } from "@/modules/login/store/types";

export default {
  name: "FormPane",
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });
    return { t };
  },
  components: {
    LoginForm,
    ChangePasswordForm,
  },
  computed: {
    ...mapGetters({
      systemMode: RootGetters.GET_SYSTEM_MODE,
    }),
    ...mapGetters("loginModule", {
      isInLoginMode: LoginGetters.GET_IS_LOGIN_MODE,
      passwordPolicy: LoginGetters.GET_PASSWORD_POLICY,
      errorMessage: LoginGetters.GET_ERROR_MESSAGE,
    }),
  },
  methods: {
    ...mapActions("loginModule", {
      login: LoginActions.LOGIN,
      changePassword: LoginActions.CHANGE_PASSWORD,
    }),
  },
};
